import React from 'react';
import { AlertTriangleIcon, XIcon, ShieldAlertIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-slate-900 border-y border-slate-800 relative" data-id="element-190">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-191">
        <div className="text-center mb-16" data-id="element-192">
          <ShieldAlertIcon className="h-12 w-12 text-red-500 mx-auto mb-6 opacity-80" data-id="element-193" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-194">
            La incertidumbre es tu peor enemiga
          </h2>
          <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-195">
            En una cita, en una reunión de negocios o en una conversación
            difícil con tu pareja. Confiar en la persona equivocada te cuesta
            tiempo, dinero y salud mental.
          </p>
        </div>

        <div className="bg-slate-800/50 border border-slate-700 p-6 md:p-8 rounded-2xl max-w-4xl mx-auto mb-16" data-id="element-196">
          <p className="text-xl text-slate-200 text-center font-medium" data-id="element-197">
            La mayoría de la gente cree que un mentiroso desvía la mirada o se
            pone nervioso.{' '}
            <span className="text-red-400 font-bold" data-id="element-198">Error.</span>
          </p>
          <p className="text-xl text-slate-300 text-center mt-4" data-id="element-199">
            Los manipuladores más peligrosos te miran a los ojos mientras te
            engañan. Si sigues buscando las señales equivocadas, seguirás siendo
            una víctima fácil.
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-200">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-201">
            Por qué lo que has intentado NO funciona:
          </h3>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-202">
            <div className="bg-slate-800/30 border border-slate-700/50 p-6 rounded-xl flex items-start" data-id="element-203">
              <div className="bg-red-500/10 p-2 rounded-lg mr-4 mt-1" data-id="element-204">
                <XIcon className="h-6 w-6 text-red-400" data-id="element-205" />
              </div>
              <div data-id="element-206">
                <h4 className="text-lg font-bold text-slate-200 mb-2" data-id="element-207">
                  Mitos Populares
                </h4>
                <p className="text-slate-400" data-id="element-208">
                  Los mitos del lenguaje corporal (como cruzar los brazos) son
                  generalizaciones que no funcionan en la vida real.
                </p>
              </div>
            </div>

            <div className="bg-slate-800/30 border border-slate-700/50 p-6 rounded-xl flex items-start" data-id="element-209">
              <div className="bg-red-500/10 p-2 rounded-lg mr-4 mt-1" data-id="element-210">
                <XIcon className="h-6 w-6 text-red-400" data-id="element-211" />
              </div>
              <div data-id="element-212">
                <h4 className="text-lg font-bold text-slate-200 mb-2" data-id="element-213">
                  Falta de Contexto
                </h4>
                <p className="text-slate-400" data-id="element-214">
                  Analizar gestos aislados no sirve de nada si no conoces la
                  "Línea Base" de la persona.
                </p>
              </div>
            </div>

            <div className="bg-slate-800/30 border border-slate-700/50 p-6 rounded-xl flex items-start" data-id="element-215">
              <div className="bg-red-500/10 p-2 rounded-lg mr-4 mt-1" data-id="element-216">
                <XIcon className="h-6 w-6 text-red-400" data-id="element-217" />
              </div>
              <div data-id="element-218">
                <h4 className="text-lg font-bold text-slate-200 mb-2" data-id="element-219">
                  Sesgo Personal
                </h4>
                <p className="text-slate-400" data-id="element-220">
                  Intentar "adivinar" por instinto te lleva a cometer errores
                  basados en tus propios miedos, no en la realidad.
                </p>
              </div>
            </div>

            <div className="bg-slate-800/30 border border-slate-700/50 p-6 rounded-xl flex items-start" data-id="element-221">
              <div className="bg-red-500/10 p-2 rounded-lg mr-4 mt-1" data-id="element-222">
                <XIcon className="h-6 w-6 text-red-400" data-id="element-223" />
              </div>
              <div data-id="element-224">
                <h4 className="text-lg font-bold text-slate-200 mb-2" data-id="element-225">
                  Información Incompleta
                </h4>
                <p className="text-slate-400" data-id="element-226">
                  Buscar tutoriales gratuitos en internet solo te da piezas
                  sueltas de un rompecabezas incompleto.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}